<template>
	<a class="item" :href="url" @click.prevent="go">
		<span class="icon" v-html="icon('email')"></span>
		Subscribe
	</a>
</template>

<script>
import {res} from "../../modules/utils";

export default {
	data() {
		return {
			subscribe: false,
			url: "https://forms.gle/c8sySjNEEwvy18CT9"
		};
	},
	computed: {
		res() {
			return res();
		}
	},
	methods: {
		go() {
			goatevent({
				path: location.host + `-hero-subscribe`,
				title: `hero subscribe`,
				event: true
			});

			if (this.res) {
				window.open(this.url, "_blank");
			} else {
				this.$store.state.subscribe = true;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
$color: $grey2;

.item {
	background-color: $color1-dark;
	margin: 0.5em;
	padding: 0.25em 0.5em;
	font-size: 0.6em;
	border-radius: 2px;
	text-transform: uppercase;
	font-weight: 600;
	color: $color;
	line-height: 1em;
	display: inline-flex;
	align-items: center;
	transition: background-color $aniTime $aniTiming;

	&:hover {
		background-color: darken($color1-dark, 8%);
	}

	.icon {
		display: inline-flex;
		margin-right: 0.4em;

		::v-deep {
			svg {
				$s: 1.55em;
				width: $s;
				height: $s;

				path {
					fill: $color;
				}
			}
		}
	}
}
</style>
